import { createContext } from 'react';

const BillManagementContext = createContext({});

export default BillManagementContext;
